webpackJsonp([9],{

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body || null);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 100 | 0) == 2, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "W/tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Latest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unfetch__ = __webpack_require__("QAmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_router_match__);


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TOURDATA = 'https://kennymason.airplug.io/catalog.json';
// https://russ-catalog.airplug.io/latest.json
// https://api.airtable.com/v0/app4bpp7Je97fEZy9/catalog?api_key=keyZ90pUeAECN3cs0

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	__WEBPACK_IMPORTED_MODULE_2_preact_router_match__["Link"],
	{ href: '/' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': 'marquee shop' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'span',
			null,
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			),
			'BUY THE MERCH ',
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'i',
				{ 'class': 'middot' },
				'\xB7'
			)
		)
	)
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'clearfix' });

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'clearfix' });

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('progress-spinner', { style: 'font-size:50px; position:absolute; top:50%; left:50%; margin:-25px 0 0 -25px;' });

var Latest = function (_Component) {
	_inherits(Latest, _Component);

	function Latest() {
		_classCallCheck(this, Latest);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Latest.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		Object(__WEBPACK_IMPORTED_MODULE_1_unfetch__["default"])(TOURDATA).then(function (r) {
			return r.json();
		}).then(function (resp) {
			var futureRecords = resp.records.filter(function (record) {
				return record.fields.is == true;
			});
			_this2.setState({ records: futureRecords });
		});
	};

	Latest.prototype.render = function render(_ref, _ref2) {
		var _ref2$records = _ref2.records,
		    records = _ref2$records === undefined ? [] : _ref2$records;

		_objectDestructuringEmpty(_ref);

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ className: 'page page__tour' },
			_ref3,
			_ref4,
			records ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'list' },
				records.map(function (song) {
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Song, { song: song });
				}),
				_ref5,
				_ref6
			) : _ref7
		);
	};

	return Latest;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);



var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'clearfix' });

var Song = function Song(_ref8) {
	var song = _ref8.song;
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': 'songsong' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'songContain' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'h3',
				null,
				song.fields.Title,
				' '
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'h3',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: song.fields.cover }),
				' '
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'songLinks' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.spotify && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.spotify, target: '_blank' },
						'spotify'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.apple && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.apple, target: '_blank' },
						'apple'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.youtube && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.youtube, target: '_blank' },
						'Youtube'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.itunes && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.itunes, target: '_blank' },
						'itunes'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.soundcloud && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.soundcloud, target: '_blank' },
						'Soundcloud'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.deezer && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.deezer, target: '_blank' },
						'Deezer'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.tidal && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.tidal, target: '_blank' },
						'Tidal'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.pandora && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.pandora, target: '_blank' },
						'pandora'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.amazon && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.amazon, target: '_blank' },
						'Amazon'
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					null,
					song.fields.audiomack && Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'a',
						{ href: song.fields.audiomack, target: '_blank' },
						'audiomack'
					)
				)
			)
		),
		_ref9
	);
};

/***/ })

});


// WEBPACK FOOTER //
// route-listen.chunk.51013.js